import { teamMembers } from '@/mocks/team';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://biffdigital.com';

export default function TeamSection() {
  return (
    <section id="team" className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
            EKİBİMİZ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
            UZMAN KADRO
          </h2>
          <p className="text-sm md:text-base text-foreground-400 mt-3 font-medium max-w-xl speakable-summary">
            BIFF Digital, stratejistlerden kreatif direktörlere, yazılım geliştiricilerden sosyal medya uzmanlarına kadar multidisipliner bir ekiple hizmet verir. Her projede doğru uzmanı sahaya sürer, kolektif zekayla sonuç üretiriz.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {teamMembers.map((member, idx) => (
            <div
              key={idx}
              className="glass-card-hover rounded-2xl p-6 md:p-7 group flex flex-col"
            >
              {/* Member Photo */}
              <div className="relative w-full aspect-square rounded-xl overflow-hidden mb-5 bg-background-200">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.title}`}
                  title={`${member.name} - ${member.title}`}
                  width="400"
                  height="400"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Name & Title */}
              <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-1">
                {member.name}
              </h3>
              <p className="text-sm font-semibold text-primary-500 mb-3">
                {member.title}
              </p>

              {/* Bio */}
              <p className="text-sm text-foreground-400 leading-relaxed flex-1 mb-4">
                {member.bio}
              </p>

              {/* LinkedIn */}
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors mt-auto group/link"
                aria-label={`${member.name} LinkedIn profili`}
              >
                <i className="ri-linkedin-box-fill text-lg" />
                <span className="group-hover/link:underline">LinkedIn</span>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom CTA — Join the team */}
        <div className="mt-12 md:mt-16 glass-card rounded-2xl p-6 md:p-8 text-center">
          <div className="w-14 h-14 bg-primary-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-user-add-line text-2xl text-primary-500" />
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-2">
            Ekibimize Katılmak İster misiniz?
          </h3>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto mb-6">
            Sürekli büyüyen ekibimizde yetenekli profesyonellere her zaman yer var. Özgeçmişinizi bize gönderin, sizi tanıyalım.
          </p>
          <a
            href={`${siteUrl}/#contact`}
            className="btn-primary"
          >
            <i className="ri-mail-send-line" />
            Bize Ulaşın
          </a>
        </div>
      </div>
    </section>
  );
}